import FieldInput from '../../../Form/Fields/FieldInput'
import StateSelect from '../../../Form/Fields/SelectFields/StateSelect'
import MaskedInput from '../../../Form/Fields/MaskedInput'

const AdditionalEmploymentFieldConfig = (employmentIndex: number) => ({
  key: employmentIndex,
  rows: [
    {
      row: 1,
      columns: [
        {
          column: 1,
          fields: [
            {
              name: 'name',
              label: 'Employer Name',
              required: true,
              component: FieldInput,
            },
          ],
        },
      ],
    },
    {
      row: 2,
      columns: [
        {
          column: 1,
          columnWidth: 'sm:tw-col-span-4 lg:tw-col-span-3',
          fields: [
            {
              name: 'phone',
              label: 'Phone',
              required: true,
              component: MaskedInput,
              mask: 'phone',
              autoComplete: 'tel-national',
            },
          ],
        },
      ],
    },
    {
      row: 3,
      columns: [
        {
          column: 1,
          fields: [
            {
              name: 'address1',
              label: 'Address',
              required: true,
              component: FieldInput,
              autoComplete: 'address-line1',
            },
          ],
        },
      ],
    },
    {
      row: 4,
      columns: [
        {
          column: 1,
          fields: [
            {
              name: 'address2',
              label: 'Address 2',
              component: FieldInput,
              autoComplete: 'address-line2',
            },
          ],
        },
      ],
    },
    {
      row: 5,
      columns: [
        {
          column: 1,
          columnWidth: 'sm:tw-col-span-5',
          fields: [
            {
              name: 'city',
              label: 'City',
              required: true,
              component: FieldInput,
              autoComplete: 'address-level2',
            },
          ],
        },
        {
          column: 2,
          columnWidth: 'sm:tw-col-span-4 lg:tw-col-span-5',
          fields: [
            {
              name: 'state',
              label: 'State',
              required: true,
              component: StateSelect,
            },
          ],
        },
        {
          column: 3,
          columnWidth: 'sm:tw-col-span-3 lg:tw-col-span-2',
          fields: [
            {
              name: 'zipCode',
              label: 'ZIP Code',
              required: true,
              component: MaskedInput,
              mask: 'zipCode',
              autoComplete: 'postal-code',
            },
          ],
        },
      ],
    },
    {
      row: 6,
      columns: [
        {
          column: 1,
          fields: [
            {
              name: 'jobTitle',
              label: 'Job Title',
              required: true,
              component: FieldInput,
            },
          ],
        },
      ],
    },
    {
      row: 7,
      columns: [
        {
          column: 1,
          columnWidth: 'sm:tw-col-span-3 lg:tw-col-span-2',
          fields: [
            {
              name: 'employmentYears',
              label: 'How Long',
              postLabel: 'Years',
              required: true,
              component: FieldInput,
              type: 'number',
              max: 110,
              className: 'tw-text-center xs:tw-px-1',
            },
          ],
        },
        {
          column: 2,
          columnWidth: 'sm:tw-col-span-3 lg:tw-col-span-2',
          fields: [
            {
              name: 'employmentMonths',
              label: 'displayNone',
              postLabel: 'Months',
              required: true,
              component: FieldInput,
              type: 'number',
              max: 11,
              className: 'tw-text-center xs:tw-px-1',
            },
          ],
        },
      ],
    },
  ],
})

export default AdditionalEmploymentFieldConfig
